import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as BrandService from '../Services/BrandService';
import Header from '../Components/Heading.js';
import EditBrand from '../Components/EditBrand.js';
import ArticleSideBar from '../Components/ArticleSideBar';

export default function UpdateBrand(props) {
	const { domain, slug } = useParams();
	const [ page, setPage ] = useState(null);
	useEffect(() => {
		BrandService.getBrand(domain,slug).then((a) => {
			console.log(a);
			setPage(a);
		});
	}, []);
	return (
		<div className="grid justify-items-center">
			<div className="flex">
				<aside className="h-screen sticky top-0 mr-3 pr-2 border-r-2  w-1/4">
					<br />
					<br />
					<br />
					<br />
					<br />
					{page && (
						<ArticleSideBar
							type="UPDATE"
							domain={page.domain}
							slug={page.url}
							isPage={true}
						/>
					)}
				</aside>
				<main className="w-3/4">
					<Header text="Update Brands" type="h1" />
					{page && <EditBrand type="UPDATE" existingValues={page} />}
				</main>
			</div>
		</div>
	);
}
